import ReactECharts from "echarts-for-react";
import "echarts-wordcloud";
import { getL1SheetProperty } from "../../../features/reduxworkbook/WorkbookSlice";
import { useSelector } from "react-redux";
import { getColourSchemeByID } from "../../../Colors/ColorPalettes";
import { getSheetControls } from "../../../features/reduxworkbook/WorkbookControllingSlice";
import { formatNumber } from "../Utils/FormatNumbers";
import { treeTransformDataEchart } from "../Utils/treeTransformDataEchart";

const TreeChartComp = ({
  Data,
  Sheetid,
  valueKeys,
  toolTipKeys,
  rowKeys: rawGroupByKeys,
  groupByKeys: rawRowKeys,
}) => {
  // console.log(Data, rawGroupByKeys, valueKeys, rawRowKeys, toolTipKeys);

  // transform
  const rowKeys = rawRowKeys.map((item) => item.responseKey) || [];

  const groupByKeys = rawGroupByKeys.map((item) => item.responseKey) || [];
  // console.log(groupByKeys);
  const transformedData = treeTransformDataEchart(
    Data,
    rowKeys[0],
    groupByKeys[0],
    valueKeys[0],
    toolTipKeys,
    rawRowKeys[0]
  );
  // console.log(transformedData);

  const customizationObject = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "customization")
  );
  const isAnimataionOff = useSelector(
    getSheetControls({ Sheetid: Sheetid, key: "isAnimataionOff" })
  );

  const {
    colorSchemeid,
    transparency = 100,
    isLabelVisible,
    labelFontSize = 14,
    labelPosition = "bottom",
    labelFontColor = "",
    colorMapping,

    isLabelDistusageTreeVisible,
    labelDistusageTreeFontSize,
    labelDistusageTreeFontColor,
    labelContentsforDistusagetree,

    labelContents,
  } = customizationObject;
  // console.log(labelDistusageTreeFontColor);

  // console.log(colorMapping);

  const colorScheme = getColourSchemeByID(colorSchemeid);
  const COLORS = colorScheme?.colors || [];
  // console.log(COLORS);

  const rowKey =
    rawRowKeys?.[0]?.responseKey || rawGroupByKeys?.[0]?.responseKey;
  const valueKey = valueKeys?.[0]?.responseKey;
  // console.log(rowKey, valueKey);

  //tree
  if (
    !transformedData ||
    !transformedData.children ||
    transformedData.children.length === 0
  ) {
    return <div>No data available for the chart.</div>;
  }

  const option = {
    tooltip: {
      backgroundColor: "transparent", // This controls the global tooltip container background
      borderWidth: 0,
      padding: 0,
      formatter: (info) => {
        // console.log(toolTipKeys, info);
        // console.log(valueKey);

        const values = valueKey;
        // console.log(values, valueKeys[0]);

        const numberFormat = valueKeys?.[0]?.numberFormat;
        const formattedValue = formatNumber(info.value, numberFormat);

        const names = info.treePathInfo
          .slice(1) // Skip root
          .map((node) => node.name);

        // Remove duplicate last two names if same
        if (names.length >= 2 && names.at(-1) === names.at(-2)) {
          names.pop();
        }

        const path = names.join("<br/>");

        const dataItem = info?.rawData || {};
        // console.log(dataItem);

        const heading = `<div style="font-weight: 600; font-size: 16px;">${path}</div>`;
        const content = `<div style="font-size: 15px; margin-top: 2px;">${values}:</span> ${formattedValue}</div>`;
        // const additional = ""
        const additional = toolTipKeys
          ?.map(({ responseKey, caption, numberFormat }) => {
            const label = caption || responseKey;

            const dataItem = Array.isArray(Data) ? Data[0] : Data;
            const rawValue = dataItem?.[responseKey];

            // Convert to number if it's numeric-like
            const isNumeric =
              !isNaN(rawValue) && rawValue !== null && rawValue !== "";
            const value = isNumeric ? Number(rawValue) : rawValue ?? "N/A";

            const formattedValue = isNumeric
              ? formatNumber(value, numberFormat) // Apply dynamic formatting
              : value;

            return `<div style="font-size: 15px; color: #4B5563;">${label}: ${formattedValue}</div>`;
          })
          .join("");

        return `
      <div style="
        background-color: transparent;
        padding: 0;
        margin: 0;
      ">
        <div style="
          background: rgba(255, 255, 255, 0.9);
         box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          border-radius: 6px;
          padding: 10px;
          color: #374151;
          font-family: sans-serif;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        ">
          ${heading}
          ${content}
          ${additional}
        </div>
      </div>
    `;
      },

      extraCssText: "pointer-events: auto;",
    },

    series: [
      {
        type: "treemap",
        data: transformedData.children.map((node, index) => ({
          ...node,
          itemStyle: {
            color: COLORS[index % COLORS.length],
            borderColor: "#fff",
            borderWidth: 4,
            gapWidth: 4,
          },
        })),

        leafDepth: 2, // Depth at which leaf nodes are displayed

        breadcrumb: { show: false },
        label: {
          show: isLabelDistusageTreeVisible,
          formatter: "{b}", // Shows the name of the node
          fontSize: labelDistusageTreeFontSize,
          color: labelDistusageTreeFontColor,
          formatter: function (params) {
            const responseKey = labelContentsforDistusagetree?.value || "value";
            const numberFormat = valueKeys?.[0]?.numberFormat;
            const dataItem = params?.data;

            const rawValue = dataItem?.[responseKey];
            const isNumeric = typeof rawValue === "number";

            if (isNumeric) {
              const formatted = formatNumber(rawValue, numberFormat);
              return formatted;
            } else {
              return params.name || "N/A";
            }
          },
        },

        levels: [
          {
            itemStyle: {
              borderColor: "#fff",
              borderWidth: 4,

              gapWidth: 4,
            },
          },
          {
            colorSaturation: [0.3, 0.6],
            itemStyle: {
              borderColorSaturation: 0.7,
              gapWidth: 2,
              borderWidth: 2,
            },
          },
        ],
      },
    ],
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <ReactECharts option={option} style={{ height: "100%", width: "100%" }} />
    </div>
  );
};

export default TreeChartComp;
